import { Flex, InputGroup, InputLeftElement, useToast } from '@chakra-ui/react'
import { ModalBody } from './styles'
import { useEffect, useState } from 'react'
import { iDefinicaoPorColab, IEmployee, iParticipanteFeedbackResponse, iPostAvaliador } from '../../../../../interfaces'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'
import { appApi, urlApi } from '../../../../../services/appApi'
import { ModalAddParticipante } from '../ModalAddParticipante'
import { GridColumn } from '../../../../PesquisaPercepcao/Participantes/styles'
import { FaFileCsv, FaSearch } from 'react-icons/fa'
import { InputCmp } from '../../../../../components/InputCmp'
import { CardParticipante } from '../CardParticipante'
import LoadingContainer from '../../../../../components/LoadingContainer'
import { ModalCadastroEmMassa } from '../ModalCadastroEmMassa'
import { useParams } from 'react-router-dom'
import { parseJwt } from '../../../../../services/token'
import { MdGroup } from 'react-icons/md'
import { ModalJaTrabalhadas } from '../ModalJaTrabalhadas'
import { ModalDelete } from '../../../../../components/ModalDelete'

interface iModal {
  isOpen: boolean
  isLoadingParticipantes: boolean
  temPDI: boolean
  feedbackId: string
  onRequestClose: () => void
  onGetParticipantes: (dontChangeAll: boolean) => void
  onGetParticipante: (participanteId: string) => void
  participantes: iParticipanteFeedbackResponse[]
}

export interface iEixosPesquisa {
  lider: IEmployee[]
  pares: IEmployee[]
  outros: IEmployee[]
  altaLideranca: IEmployee[]
  liderados: IEmployee[]
}

interface onAddParticipante {
  participanteId: string
  tipo: number
  colaborador?: iPostAvaliador
}

export const ModalGestaoPesquisa: React.FC<iModal> = ({ onRequestClose, isLoadingParticipantes, isOpen, feedbackId, participantes, onGetParticipante, onGetParticipantes, temPDI }) => {
  const { id } = useParams<{id: string}>()
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)
  const [ModalCadastroIsOpen, setModalCadastroIsOpen] = useState(false)
  const [ModalAddParticipanteIsOpen, setModalAddParticipanteIsOpen] = useState<onAddParticipante>()
  const [JaTrabalhadasIsOpen, setJaTrabalhadasIsOpen] = useState(false)
  const [AddAutoConfirm, setAddAutoConfirm] = useState(false)
  const [ColaboradorSelecionadoId, setColaboradorSelecionadoId] = useState('')
  const [Search, setSearch] = useState('')
  function onOpenModal(tipo: number, participanteId: string, colaboradorEdit?: iPostAvaliador): void {
    setModalAddParticipanteIsOpen({ colaborador: colaboradorEdit, participanteId: participanteId, tipo: tipo })
  }

  function GetJaAdicionados(participanteId: string): string[] {
    const response: string[] = []

    const participante = participantes.find(e => e.id === participanteId)
    if (!participante) return []

    participante.respondentesPesquisa?.forEach((e) => { if (e.colaboradorId) { response.push(e.colaboradorId) } })

    return response
  }

  function AddAvaliador(form: iPostAvaliador, participanteId: string): void {
    if (!ModalAddParticipanteIsOpen) return
    const response: iPostAvaliador = { ...form, tipoAvaliador: ModalAddParticipanteIsOpen.tipo }

    appApi.post(`FeedbackPersonalizado/${feedbackId}/Participante/${participanteId}/GestaoParticipantes`, response)
      .then(() => onGetParticipante(participanteId))
      .catch((err) => console.log(err))
      .finally(() => {
        onCloseAdd()
        toast({
          title: 'Participante adicionado com sucesso',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
      })
  }

  function onAddAuto(toastOn?: boolean): void {
    setIsLoading(true)
    appApi.post(`FeedbackPersonalizado/${feedbackId}/GestaoParticipantes/Automatico`)
      .then(() => onGetParticipantes(true))
      .catch((err) => console.log(err))
      .finally(() => {
        if (toastOn) {
          toast({
            title: 'Participantes adicionados com sucesso',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        }
        setIsLoading(false)
      })
  }

  function UpdateAvaliador(form: iPostAvaliador, email: string, participanteId: string): void {
    if (!ModalAddParticipanteIsOpen) return
    const response: iPostAvaliador = { ...form, tipoAvaliador: ModalAddParticipanteIsOpen.tipo }

    appApi.patch(`FeedbackPersonalizado/${feedbackId}/Participante/${participanteId}/GestaoParticipantes?emailAntigo=${email}`, response)
      .then(() => onGetParticipante(participanteId))
      .catch((err) => console.log(err))
      .finally(() => {
        onCloseAdd()
        toast({
          title: 'Participante atualizado com sucesso',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
      })
  }

  function DeleteAvaliador(form: iPostAvaliador, participanteId: string): void {
    appApi.delete(`FeedbackPersonalizado/${feedbackId}/Participante/${participanteId}/GestaoParticipantes?email=${form.email}&colaboradorId=${form.colaboradorId ? form.colaboradorId : ''}`)
      .then(() => onGetParticipante(participanteId))
      .catch((err) => console.log(err))
      .finally(() => {
        onCloseAdd()
        toast({
          title: 'Participante excluído com sucesso',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
      })
  }

  function onCloseAdd(): void {
    setModalAddParticipanteIsOpen(undefined)
  }

  function OnSaveDefinicoes(colaboradorId: string, definicoes: iDefinicaoPorColab[]): void {
    appApi.patch(`FeedbackPersonalizado/${feedbackId}/MudarDefinicoes/${colaboradorId}`, { list: definicoes })
      .then(res => {
        toast({
          title: 'Competências atualizadas com sucesso',
          status: 'success',
          position: 'top',
          duration: 4000
        })
        setJaTrabalhadasIsOpen(false)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    if (participantes.length > 0 && !participantes.some(e => e.respondentesPesquisa !== null && e.respondentesPesquisa !== undefined && e.respondentesPesquisa?.length > 0)) {
      onAddAuto()
    }
  }, [participantes])

  return (
    <ModalBase
      Titulo='Ajustar participantes das futuras pesquisas'
      isOpen={isOpen}
      onClose={onRequestClose}
      Width='54rem'
    >
      <ModalDelete
        isOpen={AddAutoConfirm}
        message='Ao restaurar para o padrão do sistema, todas as suas alterações serão perdidas. Tem certeza que deseja continuar?'
        onConfirm={() => onAddAuto(true)}
        onRequestClose={() => setAddAutoConfirm(false)}
        center
      />
      <ModalJaTrabalhadas
        OnCloseModal={() => setJaTrabalhadasIsOpen(false)}
        colaboradorId={ColaboradorSelecionadoId}
        iniciado={participantes.some(e => e.colaborador && e.colaborador.id === ColaboradorSelecionadoId && e.emailsEnviados.includes(ColaboradorSelecionadoId))}
        isOpen={JaTrabalhadasIsOpen}
        onSave={OnSaveDefinicoes}
        feedbackId={feedbackId}
      />
      {ModalCadastroIsOpen && <ModalCadastroEmMassa
        isOpen={ModalCadastroIsOpen}
        onRequestClose={() => setModalCadastroIsOpen(false)}
        reload={() => onGetParticipantes(true)}
      />}
      {ModalAddParticipanteIsOpen && (
        <ModalAddParticipante
          jaAdicionados={GetJaAdicionados(ModalAddParticipanteIsOpen.participanteId)}
          isOpen={!!ModalAddParticipanteIsOpen}
          onConfirm={(avaliador) => AddAvaliador(avaliador, ModalAddParticipanteIsOpen.participanteId)}
          onRequestClose={onCloseAdd}
          onUpdateAvaliador={(avaliador, email) => UpdateAvaliador(avaliador, email, ModalAddParticipanteIsOpen.participanteId)}
          onDeleteAvaliador={(avaliador) => DeleteAvaliador(avaliador, ModalAddParticipanteIsOpen.participanteId)}
          colaborador={ModalAddParticipanteIsOpen.colaborador}
        />
      )}
      <ModalBody>
        <LoadingContainer linhas={20} loading={IsLoading || isLoadingParticipantes}>
          <GridColumn>
            <Flex justifyContent={'space-between'} mb={'1rem'}>
              <InputGroup width={'15rem'}>
                <InputLeftElement
                  h={'1.75rem'}
                  pointerEvents='none'
                  children={<FaSearch color='var(--Gray4)' />}
                />
                <InputCmp
                  pl={'2.25rem'}
                  OnChange={setSearch}
                  borderColor={'var(--Gray4)'}
                  type='text'
                  placeholder='Digite o nome do avaliado'
                  bg={'white'}
                />
              </InputGroup>
              <Flex gap={'1rem'}>
                <ButtonCmp
                  onClick={() => { window.location.href = `${urlApi}/FeedbackPersonalizado/${id}/Csv?empresaId=${parseJwt().eid}` }}
                  VarColor='Roxo'
                  leftIcon={<MdGroup color='var(--c1)'/>}
                >Exportar participantes</ButtonCmp>
                <ButtonCmp VarColor='Rosa' onClick={() => setModalCadastroIsOpen(true)} leftIcon={<FaFileCsv color='var(--c1)'/>}>Ajustar em massa</ButtonCmp>
              </Flex>
            </Flex>
            {
              participantes.filter((e) => {
                if (Search === '') {
                  return e
                } else if (e.colaborador?.nome.toLowerCase().includes(Search.toLowerCase())) {
                  return e
                } else {
                  return null
                }
              }).map((e: iParticipanteFeedbackResponse) => {
                return (
                  <CardParticipante
                    key={e.id}
                    Avaliacao={e}
                    disabled={e.emailsEnviados.includes(e.colaborador?.id ?? '')}
                    onOpenModal={onOpenModal}
                    onOpenJaTrabalhadas={(avaliacaoId) => { setColaboradorSelecionadoId(avaliacaoId); setJaTrabalhadasIsOpen(true) }}
                    onEdit={(avaliador) => onOpenModal(avaliador.tipoAvaliador, e.id, avaliador)}
                    temPDI={temPDI}
                  />
                )
              })
            }
          </GridColumn>
        </LoadingContainer>
      </ModalBody>
      <Flex justifyContent={'end'} padding='1rem' gap={'.5rem'}>
        <ButtonCmp
          onClick={onRequestClose}
          VarColor='c6'
        >Voltar</ButtonCmp>

        <ButtonCmp
          onClick={() => setAddAutoConfirm(true)}
          VarColor='Rosa'
        >Restaurar para o padrão do sistema</ButtonCmp>

        <ButtonCmp
          onClick={onRequestClose}
          VarColor='Green2'
        >Salvar</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
